// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.App {
  display: flex;
  margin: 0;
  position: relative;
  background-color: var(--rm-bg);
}
.App .assets_view {
  flex: 2 1;
  margin: 8px;
  display: flex;
  flex-direction: column;
  background-color: var(--rm-surface);
  border-radius: var(--rm-radius-lg);
  border: 1px solid var(--rm-border);
  box-shadow: var(--rm-shadow-sm);
  height: 101vh;
  margin-bottom: 0px;
  overflow: auto;
}
.App .assets_view .single_asset {
  background: var(--rm-surface);
  border: 1px solid var(--rm-border);
  border-radius: var(--rm-radius);
  display: flex;
  margin: 3px 10px;
  overflow: hidden;
  padding: 10px 12px;
  color: var(--rm-text);
  align-items: center;
  gap: 6px;
  transition: border-color var(--rm-transition), box-shadow var(--rm-transition), background var(--rm-transition);
  cursor: pointer;
}
.App .assets_view .single_asset:hover {
  border-color: var(--rm-primary-border);
  box-shadow: 0 2px 6px var(--rm-primary-dim);
  background: rgba(38, 144, 68, 0.02);
}
.App .assets_view .single_asset .asset_title {
  display: flex;
  flex-direction: column;
  flex: 1 1;
  min-width: 0;
}
.App .assets_view .single_asset .asset_title div:first-child {
  font-weight: 600;
  font-size: 13px;
  color: var(--rm-text);
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
.App .assets_view .single_asset .asset_title div:last-child {
  font-size: 11px;
  color: var(--rm-text-muted);
  margin-top: 2px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
.App .assets_view .single_asset .show_icon {
  flex: 0 0 auto;
  cursor: pointer;
  color: var(--rm-text-muted);
  display: flex;
  align-items: center;
  justify-content: center;
  width: 30px;
  height: 30px;
  border-radius: var(--rm-radius);
  transition: color var(--rm-transition), background var(--rm-transition);
}
.App .assets_view .single_asset .show_icon svg {
  font-size: 18px;
}
.App .assets_view .single_asset .show_icon:hover {
  color: var(--rm-primary);
  background: var(--rm-primary-dim);
}
.App .assets_view .single_asset .delete_icon {
  flex: 0 0 auto;
  cursor: pointer;
  color: var(--rm-text-muted);
  display: flex;
  align-items: center;
  justify-content: center;
  width: 30px;
  height: 30px;
  border-radius: var(--rm-radius);
  transition: color var(--rm-transition), background var(--rm-transition);
}
.App .assets_view .single_asset .delete_icon svg {
  font-size: 18px;
}
.App .assets_view .single_asset .delete_icon:hover {
  color: #dc3545;
  background: rgba(220, 53, 69, 0.08);
}
.App .assets_view .asset_actions {
  display: flex;
  gap: 1px;
  opacity: 0;
  transition: opacity var(--rm-transition);
}
.App .assets_view .single_asset:hover .asset_actions,
.App .assets_view .single_asset.selected .asset_actions {
  opacity: 1;
}
.App .resizable_app .pointer-events-none {
  pointer-events: none;
}
.App .resizable_app .asset_details_outer {
  background-color: var(--rm-surface);
  border-radius: var(--rm-radius-lg);
  border: 1px solid var(--rm-border);
  justify-content: space-between;
  display: flex;
  flex-direction: column;
  padding: 0;
  margin: 8px 4px 0px 4px;
  height: 100vh;
  margin-bottom: 0px;
  overflow: auto;
  box-shadow: var(--rm-shadow-sm);
}
.App .resizable_app .asset_details_outer .asset_details {
  display: flex;
  justify-content: flex-start;
  flex: 3 1;
}
.App .resizable_app .asset_details_outer .asset_details .outer_mapping {
  display: flex;
  flex-direction: column;
  padding: 10px 12px;
  border-right: 1px solid var(--rm-border);
  gap: 5px;
}
.App .resizable_app .asset_details_outer .asset_details .outer_mapping .inner_mapping {
  display: flex;
  border: 1px solid var(--rm-border);
  padding: 8px 14px;
  min-width: 150px;
  align-items: center;
  background-color: var(--rm-surface);
  color: var(--rm-text);
  border-radius: var(--rm-radius);
  justify-content: center;
  cursor: pointer;
  font-weight: 600;
  font-size: 12px;
  letter-spacing: 0.01em;
  transition: background-color var(--rm-transition), color var(--rm-transition), border-color var(--rm-transition), box-shadow var(--rm-transition);
}
.App .resizable_app .asset_details_outer .asset_details .outer_mapping .inner_mapping:hover {
  background-color: var(--rm-primary);
  color: #fff;
  border-color: var(--rm-primary);
  box-shadow: 0 2px 6px rgba(38, 144, 68, 0.25);
}
.App .resizable_app .asset_details_outer .asset_details .outer_mapping .inner_mapping_chosen {
  border: 1px solid var(--rm-primary);
  padding: 8px 14px;
  background-color: var(--rm-primary-dim);
  border-radius: var(--rm-radius);
  text-align: center;
  cursor: pointer;
  color: var(--rm-primary);
  font-weight: 600;
  font-size: 12px;
}
.App .resizable_app .asset_details_outer .asset_details .inner_submodels {
  border: 1px solid var(--rm-border);
  padding: 8px 14px;
  background-color: var(--rm-surface);
  border-radius: var(--rm-radius);
  margin: 3px;
  text-align: center;
  cursor: pointer;
  color: var(--rm-text);
  font-size: 12px;
}
.App .asset_manipulation {
  height: 101vh;
  overflow: auto;
  flex: 2 1;
  margin: 8px;
  display: flex;
  border-radius: var(--rm-radius-lg);
  border: 1px solid var(--rm-border);
  flex-direction: column;
  background-color: var(--rm-surface);
  box-shadow: var(--rm-shadow-sm);
  margin-bottom: 0px;
}
.App .left_slider {
  z-index: 1;
  position: absolute;
  background-color: rgba(0, 0, 0, 0.08);
  width: 50px;
  height: 100vh;
  opacity: 0;
}
.App .left_slider:hover {
  opacity: 0.5;
  cursor: pointer;
  transition: 1s;
}
.App .right_slider {
  flex: 0.1 1;
}
.App .right_slider:hover {
  background-color: rgba(0, 0, 0, 0.05);
  cursor: pointer;
}
.App .hierarchy_div {
  width: 30px;
  height: 30px;
  background: var(--rm-primary);
  border-radius: var(--rm-radius);
  color: white;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-top: 6px;
  transition: background-color var(--rm-transition), box-shadow var(--rm-transition);
}
.App .hierarchy_div svg {
  font-size: 18px;
}
.App .hierarchy_div:hover {
  background: var(--rm-primary-hover);
  box-shadow: 0 2px 6px rgba(38, 144, 68, 0.3);
}`, "",{"version":3,"sources":["webpack://./src/App.scss"],"names":[],"mappings":"AAAA;EACI,aAAA;EACA,SAAA;EACA,kBAAA;EACA,8BAAA;AACJ;AACI;EACI,SAAA;EACA,WAAA;EACA,aAAA;EACA,sBAAA;EACA,mCAAA;EACA,kCAAA;EACA,kCAAA;EACA,+BAAA;EACA,aAAA;EACA,kBAAA;EACA,cAAA;AACR;AACQ;EACI,6BAAA;EACA,kCAAA;EACA,+BAAA;EACA,aAAA;EACA,gBAAA;EACA,gBAAA;EACA,kBAAA;EACA,qBAAA;EACA,mBAAA;EACA,QAAA;EACA,+GAAA;EACA,eAAA;AACZ;AACY;EACI,sCAAA;EACA,2CAAA;EACA,mCAAA;AAChB;AAEY;EACI,aAAA;EACA,sBAAA;EACA,SAAA;EACA,YAAA;AAAhB;AAEgB;EACI,gBAAA;EACA,eAAA;EACA,qBAAA;EACA,mBAAA;EACA,gBAAA;EACA,uBAAA;AAApB;AAGgB;EACI,eAAA;EACA,2BAAA;EACA,eAAA;EACA,mBAAA;EACA,gBAAA;EACA,uBAAA;AADpB;AAKY;EACI,cAAA;EACA,eAAA;EACA,2BAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,WAAA;EACA,YAAA;EACA,+BAAA;EACA,uEAAA;AAHhB;AAKgB;EAAM,eAAA;AAFtB;AAIgB;EACI,wBAAA;EACA,iCAAA;AAFpB;AAMY;EACI,cAAA;EACA,eAAA;EACA,2BAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,WAAA;EACA,YAAA;EACA,+BAAA;EACA,uEAAA;AAJhB;AAMgB;EAAM,eAAA;AAHtB;AAKgB;EACI,cAAA;EACA,mCAAA;AAHpB;AAQQ;EACI,aAAA;EACA,QAAA;EACA,UAAA;EACA,wCAAA;AANZ;AASQ;;EAEI,UAAA;AAPZ;AAYQ;EACI,oBAAA;AAVZ;AAaQ;EACI,mCAAA;EACA,kCAAA;EACA,kCAAA;EACA,8BAAA;EACA,aAAA;EACA,sBAAA;EACA,UAAA;EACA,uBAAA;EACA,aAAA;EACA,kBAAA;EACA,cAAA;EACA,+BAAA;AAXZ;AAaY;EACI,aAAA;EACA,2BAAA;EACA,SAAA;AAXhB;AAagB;EACI,aAAA;EACA,sBAAA;EACA,kBAAA;EACA,wCAAA;EACA,QAAA;AAXpB;AAaoB;EACI,aAAA;EACA,kCAAA;EACA,iBAAA;EACA,gBAAA;EACA,mBAAA;EACA,mCAAA;EACA,qBAAA;EACA,+BAAA;EACA,uBAAA;EACA,eAAA;EACA,gBAAA;EACA,eAAA;EACA,sBAAA;EACA,iJAAA;AAXxB;AAawB;EACI,mCAAA;EACA,WAAA;EACA,+BAAA;EACA,6CAAA;AAX5B;AAeoB;EACI,mCAAA;EACA,iBAAA;EACA,uCAAA;EACA,+BAAA;EACA,kBAAA;EACA,eAAA;EACA,wBAAA;EACA,gBAAA;EACA,eAAA;AAbxB;AAiBgB;EACI,kCAAA;EACA,iBAAA;EACA,mCAAA;EACA,+BAAA;EACA,WAAA;EACA,kBAAA;EACA,eAAA;EACA,qBAAA;EACA,eAAA;AAfpB;AAqBI;EACI,aAAA;EACA,cAAA;EACA,SAAA;EACA,WAAA;EACA,aAAA;EACA,kCAAA;EACA,kCAAA;EACA,sBAAA;EACA,mCAAA;EACA,+BAAA;EACA,kBAAA;AAnBR;AAsBI;EACI,UAAA;EACA,kBAAA;EACA,qCAAA;EACA,WAAA;EACA,aAAA;EACA,UAAA;AApBR;AAsBQ;EACI,YAAA;EACA,eAAA;EACA,cAAA;AApBZ;AAwBI;EACI,WAAA;AAtBR;AAwBQ;EACI,qCAAA;EACA,eAAA;AAtBZ;AA0BI;EACI,WAAA;EACA,YAAA;EACA,6BAAA;EACA,+BAAA;EACA,YAAA;EACA,eAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,eAAA;EACA,kFAAA;AAxBR;AA0BQ;EAAM,eAAA;AAvBd;AAyBQ;EACI,mCAAA;EACA,4CAAA;AAvBZ","sourcesContent":[".App {\r\n    display: flex;\r\n    margin: 0;\r\n    position: relative;\r\n    background-color: var(--rm-bg);\r\n\r\n    .assets_view {\r\n        flex: 2;\r\n        margin: 8px;\r\n        display: flex;\r\n        flex-direction: column;\r\n        background-color: var(--rm-surface);\r\n        border-radius: var(--rm-radius-lg);\r\n        border: 1px solid var(--rm-border);\r\n        box-shadow: var(--rm-shadow-sm);\r\n        height: 101vh;\r\n        margin-bottom: 0px;\r\n        overflow: auto;\r\n\r\n        .single_asset {\r\n            background: var(--rm-surface);\r\n            border: 1px solid var(--rm-border);\r\n            border-radius: var(--rm-radius);\r\n            display: flex;\r\n            margin: 3px 10px;\r\n            overflow: hidden;\r\n            padding: 10px 12px;\r\n            color: var(--rm-text);\r\n            align-items: center;\r\n            gap: 6px;\r\n            transition: border-color var(--rm-transition), box-shadow var(--rm-transition), background var(--rm-transition);\r\n            cursor: pointer;\r\n\r\n            &:hover {\r\n                border-color: var(--rm-primary-border);\r\n                box-shadow: 0 2px 6px var(--rm-primary-dim);\r\n                background: rgba(38, 144, 68, 0.02);\r\n            }\r\n\r\n            .asset_title {\r\n                display: flex;\r\n                flex-direction: column;\r\n                flex: 1;\r\n                min-width: 0;\r\n\r\n                div:first-child {\r\n                    font-weight: 600;\r\n                    font-size: 13px;\r\n                    color: var(--rm-text);\r\n                    white-space: nowrap;\r\n                    overflow: hidden;\r\n                    text-overflow: ellipsis;\r\n                }\r\n\r\n                div:last-child {\r\n                    font-size: 11px;\r\n                    color: var(--rm-text-muted);\r\n                    margin-top: 2px;\r\n                    white-space: nowrap;\r\n                    overflow: hidden;\r\n                    text-overflow: ellipsis;\r\n                }\r\n            }\r\n\r\n            .show_icon {\r\n                flex: 0 0 auto;\r\n                cursor: pointer;\r\n                color: var(--rm-text-muted);\r\n                display: flex;\r\n                align-items: center;\r\n                justify-content: center;\r\n                width: 30px;\r\n                height: 30px;\r\n                border-radius: var(--rm-radius);\r\n                transition: color var(--rm-transition), background var(--rm-transition);\r\n\r\n                svg { font-size: 18px; }\r\n\r\n                &:hover {\r\n                    color: var(--rm-primary);\r\n                    background: var(--rm-primary-dim);\r\n                }\r\n            }\r\n\r\n            .delete_icon {\r\n                flex: 0 0 auto;\r\n                cursor: pointer;\r\n                color: var(--rm-text-muted);\r\n                display: flex;\r\n                align-items: center;\r\n                justify-content: center;\r\n                width: 30px;\r\n                height: 30px;\r\n                border-radius: var(--rm-radius);\r\n                transition: color var(--rm-transition), background var(--rm-transition);\r\n\r\n                svg { font-size: 18px; }\r\n\r\n                &:hover {\r\n                    color: #dc3545;\r\n                    background: rgba(220, 53, 69, 0.08);\r\n                }\r\n            }\r\n        }\r\n\r\n        .asset_actions {\r\n            display: flex;\r\n            gap: 1px;\r\n            opacity: 0;\r\n            transition: opacity var(--rm-transition);\r\n        }\r\n\r\n        .single_asset:hover .asset_actions,\r\n        .single_asset.selected .asset_actions {\r\n            opacity: 1;\r\n        }\r\n    }\r\n\r\n    .resizable_app {\r\n        .pointer-events-none {\r\n            pointer-events: none;\r\n        }\r\n\r\n        .asset_details_outer {\r\n            background-color: var(--rm-surface);\r\n            border-radius: var(--rm-radius-lg);\r\n            border: 1px solid var(--rm-border);\r\n            justify-content: space-between;\r\n            display: flex;\r\n            flex-direction: column;\r\n            padding: 0;\r\n            margin: 8px 4px 0px 4px;\r\n            height: 100vh;\r\n            margin-bottom: 0px;\r\n            overflow: auto;\r\n            box-shadow: var(--rm-shadow-sm);\r\n\r\n            .asset_details {\r\n                display: flex;\r\n                justify-content: flex-start;\r\n                flex: 3;\r\n\r\n                .outer_mapping {\r\n                    display: flex;\r\n                    flex-direction: column;\r\n                    padding: 10px 12px;\r\n                    border-right: 1px solid var(--rm-border);\r\n                    gap: 5px;\r\n\r\n                    .inner_mapping {\r\n                        display: flex;\r\n                        border: 1px solid var(--rm-border);\r\n                        padding: 8px 14px;\r\n                        min-width: 150px;\r\n                        align-items: center;\r\n                        background-color: var(--rm-surface);\r\n                        color: var(--rm-text);\r\n                        border-radius: var(--rm-radius);\r\n                        justify-content: center;\r\n                        cursor: pointer;\r\n                        font-weight: 600;\r\n                        font-size: 12px;\r\n                        letter-spacing: 0.01em;\r\n                        transition: background-color var(--rm-transition), color var(--rm-transition), border-color var(--rm-transition), box-shadow var(--rm-transition);\r\n\r\n                        &:hover {\r\n                            background-color: var(--rm-primary);\r\n                            color: #fff;\r\n                            border-color: var(--rm-primary);\r\n                            box-shadow: 0 2px 6px rgba(38, 144, 68, 0.25);\r\n                        }\r\n                    }\r\n\r\n                    .inner_mapping_chosen {\r\n                        border: 1px solid var(--rm-primary);\r\n                        padding: 8px 14px;\r\n                        background-color: var(--rm-primary-dim);\r\n                        border-radius: var(--rm-radius);\r\n                        text-align: center;\r\n                        cursor: pointer;\r\n                        color: var(--rm-primary);\r\n                        font-weight: 600;\r\n                        font-size: 12px;\r\n                    }\r\n                }\r\n\r\n                .inner_submodels {\r\n                    border: 1px solid var(--rm-border);\r\n                    padding: 8px 14px;\r\n                    background-color: var(--rm-surface);\r\n                    border-radius: var(--rm-radius);\r\n                    margin: 3px;\r\n                    text-align: center;\r\n                    cursor: pointer;\r\n                    color: var(--rm-text);\r\n                    font-size: 12px;\r\n                }\r\n            }\r\n        }\r\n    }\r\n\r\n    .asset_manipulation {\r\n        height: 101vh;\r\n        overflow: auto;\r\n        flex: 2;\r\n        margin: 8px;\r\n        display: flex;\r\n        border-radius: var(--rm-radius-lg);\r\n        border: 1px solid var(--rm-border);\r\n        flex-direction: column;\r\n        background-color: var(--rm-surface);\r\n        box-shadow: var(--rm-shadow-sm);\r\n        margin-bottom: 0px;\r\n    }\r\n\r\n    .left_slider {\r\n        z-index: 1;\r\n        position: absolute;\r\n        background-color: rgba(0, 0, 0, 0.08);\r\n        width: 50px;\r\n        height: 100vh;\r\n        opacity: 0;\r\n\r\n        &:hover {\r\n            opacity: 0.5;\r\n            cursor: pointer;\r\n            transition: 1s;\r\n        }\r\n    }\r\n\r\n    .right_slider {\r\n        flex: 0.1;\r\n\r\n        &:hover {\r\n            background-color: rgba(0, 0, 0, 0.05);\r\n            cursor: pointer;\r\n        }\r\n    }\r\n\r\n    .hierarchy_div {\r\n        width: 30px;\r\n        height: 30px;\r\n        background: var(--rm-primary);\r\n        border-radius: var(--rm-radius);\r\n        color: white;\r\n        cursor: pointer;\r\n        display: flex;\r\n        align-items: center;\r\n        justify-content: center;\r\n        margin-top: 6px;\r\n        transition: background-color var(--rm-transition), box-shadow var(--rm-transition);\r\n\r\n        svg { font-size: 18px; }\r\n\r\n        &:hover {\r\n            background: var(--rm-primary-hover);\r\n            box-shadow: 0 2px 6px rgba(38, 144, 68, 0.3);\r\n        }\r\n    }\r\n}\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
